<div>
  <app-speed-field-r #read *ngIf="RorE" [RealValue]="RealValue" [Title]="Title" [MaxNumsAfterDot]="MaxNumsAfterDot">
  </app-speed-field-r>
  <app-speed-field-w #write *ngIf="!RorE" [RealValue]="RealValue" [Title]="Title" [MaxNumsAfterDot]="MaxNumsAfterDot"
    [ShowRealVal]=true [MaxVal]="MaxVal" [MinVal]="MinVal"></app-speed-field-w>
  <button [ngClass]="RorE ? 'small-button-read-units' : 'small-button-edit'" mat-stroked-button (click)="SwitchRorE()"
    [matTooltip]="RorE ? ('ARO.SWITCH_TO_EDIT' | translate) : ('ARO.SWITCH_TO_VIEW' | translate)">
    <mat-icon class="svg-icon">{{RorE ? "edit" : "settings_backup_restore"}}</mat-icon>
  </button>
</div>